
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M21.063 39.896c-1.82-1.11-5.02-.08-4 2.94 1.02 3.02 5.25 10.38 15.4 10.38s13.74-8.23 13.74-12.87c0-4.64-3.13-5.51-4.76-5.51s-2.87 1.13-3.36 2.23c-.49 1.1-3.06 5.13-8.38 5.66-5.32.53-7.59-2.19-8.65-2.83h.01z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M30.073 48.626c5.94.96 9.03-1.19 10.67-3.89m-17.12-34.31c.39-2.1-1.71-4.72-4.17-2.7-2.46 2.02-7.85 8.58-4.25 18.08 3.6 9.5 12.57 9.93 16.91 8.29 4.34-1.64 4.04-4.88 3.47-6.4-.57-1.52-2.08-2.28-3.27-2.35-1.19-.07-5.89-1.04-8.27-5.83s-.64-7.87-.42-9.09zM18.653 21.936c1.21 5.89 4.31 8.03 7.42 8.6"}})])
          )
        }
      }
    